import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
// Initialise KaTeX globally with mhchem (chemistry) extension before any
// react-katex InlineMath/BlockMath component ever mounts. This ensures the
// \ce{...} macro is recognised everywhere in the app (RenderContent,
// EquationStudio, SectionEquations).
import "katex/dist/katex.min.css";
import "katex/dist/contrib/mhchem.js";
import App from "@/App";
import axios from "axios";
import { installTenantSuspensionWatcher } from "@/lib/tenantSuspension";
import { installGlobalErrorToasts } from "@/lib/errors";

// Spot "school suspended" API replies from any fetch/axios call (see the module).
installTenantSuspensionWatcher(axios);
// Request failures no screen handled still reach the user — as a friendly toast.
installGlobalErrorToasts();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
